import LocalStorage from 'local-storage';

export class ListFilter {
    constructor(searchField, listParent) {
        if (document.querySelector(searchField)) {
            this.searchField = document.querySelector(searchField);
            this.listParent = document.querySelector(listParent);

            this.searchField.value = LocalStorage.get(this.searchField.attributes.name.value);

            this.search();

            const scope = this;
            this.searchField.onkeyup = event => {
                scope.search();
            };
            this.searchField.onsearch = event => {
                scope.search();
            };
        }
    }

    search() {
        const query = this.searchField.value.toLowerCase();

        LocalStorage.set(this.searchField.attributes.name.value, query);

        this.listParent.querySelectorAll(':scope > ul > li').forEach(listItem => {
            listItem.querySelectorAll('li').forEach(listItem => {
                let display = 'none';

                // Search for a title based match
                const candidate = listItem.querySelector('a').text;

                if (new RegExp(`${query}`).test(candidate.toLowerCase())) {
                    display = 'block';
                }

                // Search for tag based match
                let tags = listItem.querySelector('a').dataset.tags;

                if ((tags) && (new RegExp(`${query}`).test(tags.toLowerCase()))) {
                    display = 'block';
                }

                listItem.style.display = display;
            });

            let visibleItems = 0;
            listItem.querySelectorAll('li').forEach(listItem => {
                if (listItem.style.display === 'block') {
                    visibleItems++;
                }
            });

            let display = 'none';
            if (visibleItems > 0) {
                display = 'block';
            }

            listItem.style.display = display;
        });
    }
}
